import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './services.css'

const Services = (props) => {
  return (
    <div className="services-container10">
      <Helmet>
        <title>Product Design Capabilities | Vlad Butucariu</title>
        <meta
          name="description"
          content="Product strategy, UX/UI, design systems, and AI-native prototyping capabilities for technically complex digital products."
        />
        <meta
          property="og:title"
          content="Product Design Capabilities | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="From product definition and UX/UI to scalable systems and functional AI-assisted prototypes."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/services" />
        <meta
          property="og:url"
          content="https://vladbutucariu.com/services"
        />
      </Helmet>
      <div className="services-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="services-thq-top-section-elm">
          <div className="services-thq-video-div-elm1">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="services-video1"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="services-thq-video-mobile-elm1"
            ></video>
          </div>
          <div className="services-thq-section-elm">
            <div className="services-thq-color-wrapper-elm">
              <div className="services-container11">
                <div className="services-container12">
                  <img
                    alt="image"
                    src="/Images/tickerpurple.200.svg"
                    className="services-image"
                  />
                  <div className="services-container13">
                    <h1 className="services-text10">// CAPABILITIES</h1>
                    <div className="services-container14">
                      <span className="services-text11">product design</span>
                      <span className="services-text12">systems + prototypes</span>
                    </div>
                  </div>
                </div>
                <div className="services-container15">
                  <div className="services-container16">
                    <h2 className="services-text13">
                      01. Product Strategy &amp; Definition
                    </h2>
                    <span className="services-text14">
                      I help teams define the right problem before committing to
                      a solution. That includes clarifying product goals,
                      mapping user needs, shaping an MVP, and turning technical
                      constraints into a focused product direction.
                    </span>
                  </div>
                  <div className="services-container17">
                    <h2 className="services-text15">
                      <span>02. Experience Design (UX/UI)</span>
                      <br></br>
                    </h2>
                    <span className="services-text18">
                      I translate complex logic into intuitive, human-centered
                      interfaces. My work covers user flows, information
                      architecture, interaction design, and high-fidelity
                      visual craft, with a focus on making demanding products
                      feel understandable and predictable.
                    </span>
                  </div>
                  <div className="services-container18">
                    <h2 className="services-text19">
                      <span>03. AI-Native Prototyping</span>
                      <br></br>
                    </h2>
                    <span className="services-text22">
                      Using Claude Code, Codex, and modern AI-assisted
                      workflows, I turn high-fidelity design into functional
                      prototypes quickly. This makes ideas testable earlier,
                      improves communication with engineering, and helps teams
                      make decisions using a working product rather than static
                      screens alone.
                    </span>
                  </div>
                  <div className="services-container19">
                    <h2 className="services-text23">
                      <span>04. Design Systems &amp; Scalability</span>
                      <br></br>
                    </h2>
                    <span className="services-text26">
                      I build visual languages and component systems that keep
                      products consistent as they grow. Clear patterns,
                      reusable components, and practical documentation connect
                      design decisions with implementation and reduce repeated
                      work across teams.
                    </span>
                  </div>
                  <div className="services-container20">
                    <h2 className="services-text27">
                      <span>The Process</span>
                      <br></br>
                    </h2>
                    <span className="services-text30">
                      <span>
                        _Discovery: Auditing the landscape &amp; defining the
                        problem.
                      </span>
                      <br></br>
                      <span>
                        _Definition: Wireframing the logic &amp; user journeys.
                      </span>
                      <br></br>
                      <span>
                        _Execution: High-fidelity design &amp; functional
                        prototypes.
                      </span>
                      <br></br>
                      <span>
                        _Delivery: Production-ready systems, collaboration
                        &amp; documentation.
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="services-thq-video-div-elm2">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="services-video2"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="services-video3"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="services-thq-video-mobile-elm2"
            ></video>
          </div>
        </div>
        <Footer rootClassName="footerroot-class-name3"></Footer>
      </div>
    </div>
  )
}

export default Services
